/** Customer-facing invoice portal hash URL (`/#invoice-portal?token=…`). */
export function invoicePortalUrlFromToken(token: string): string {
  const t = token.trim();
  if (typeof window === "undefined" || t === "") {
    return "";
  }
  let root = window.location.origin + (import.meta.env.BASE_URL || "/");
  if (!root.endsWith("/")) {
    root += "/";
  }

  return `${root}#invoice-portal?token=${encodeURIComponent(t)}`;
}

export function resolveInvoicePortalUrl(sale: {
  public_invoice_portal_url?: string | null;
  public_invoice_token?: string | null;
}): string | null {
  const fromApi = sale.public_invoice_portal_url?.trim();
  if (fromApi) {
    return fromApi;
  }
  const token = sale.public_invoice_token?.trim();
  if (token) {
    const built = invoicePortalUrlFromToken(token);
    return built || null;
  }

  return null;
}
